import { COLOR } from '@/theme/colors';

export const planStyles = {
    wrapper: {
        border: `1px solid ${COLOR.geyser}`,
        borderRadius: '20px',
        position: 'relative',
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: '18px',
        padding: '26px',
        minHeight: '380px',
        borderRadius: '20px 20px 0 0',
        position: 'relative',
    },
    box: {
        px: '12px',
        py: '6px',
        borderRadius: '50px',
        alignSelf: 'flex-start',
    },
};
